import { BulkNodesEditFormValues } from "@features/builder/BulkNodesEditDialog/BulkNodesEditForm/BulkNodesEditForm"
import { Checkbox } from "@mui/material"
import { useFormContext, useWatch } from "react-hook-form"

const CheckboxSelectAll = () => {
  const formMethods = useFormContext<BulkNodesEditFormValues>()

  const nodesValues =
    useWatch({
      control: formMethods.control,
      name: "nodes",
    }) ?? {}
  const allRows = Object.values(nodesValues)
  const numberOfSelectedNodes = allRows.filter((node) => node.isSelected).length

  const areAllNodesSelected = allRows.length > 0 && numberOfSelectedNodes === allRows.length
  const onlySomeSelected = numberOfSelectedNodes > 0 && !areAllNodesSelected

  const handleAllRowsSelectChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = event.target.checked
    formMethods.setValue(
      "nodes",
      Object.fromEntries(
        Object.entries(nodesValues).map(([nodeId, nodeValues]) => [
          nodeId,
          { ...nodeValues, isSelected: isChecked },
        ]),
      ),
    )
  }

  return (
    <Checkbox
      checked={areAllNodesSelected}
      indeterminate={onlySomeSelected}
      onChange={handleAllRowsSelectChange}
      disabled={formMethods.formState.disabled}
    />
  )
}

export default CheckboxSelectAll
